export default class SafeString {
  constructor (value) {
    this.value = value
  }

  toString () {
    return this.value
  }
}
